<script setup lang="ts">
import dayjs from 'dayjs';
import { onMounted } from 'vue';

interface Props {
  compromisso?: any;
}

const props = defineProps<Props>();

const emit = defineEmits(['loaded']);

onMounted(() => {
  emit('loaded');
});
</script>

<template>
  <a-descriptions
    v-if="props.compromisso.data"
    :column="3"
    :label-style="{ width: '35%' }"
    bordered
  >
    <a-descriptions-item label="Demanda" :span="3">
      {{ props.compromisso.data.demanda.id }}
    </a-descriptions-item>
    <a-descriptions-item label="Status" :span="3">
      {{ props.compromisso.data.demanda.ds_status }}
    </a-descriptions-item>
    <a-descriptions-item label="Data da criação" :span="3">
      {{
        dayjs(props.compromisso.data.demanda.created_at).format(
          'DD/MM/YYYY HH:mm',
        )
      }}
    </a-descriptions-item>
    <a-descriptions-item
      v-if="props.compromisso.data.demanda.updated_at"
      label="Data do tratamento"
      :span="3"
    >
      {{
        dayjs(props.compromisso.data.demanda.updated_at).format(
          'DD/MM/YYYY HH:mm',
        )
      }} </a-descriptions-item
    ><a-descriptions-item
      v-if="props.compromisso.data.demanda.substatus"
      label="Observação"
      :span="3"
    >
      {{ props.compromisso.data.demanda.substatus }}
    </a-descriptions-item>
  </a-descriptions>
</template>
